

























































import Vue from 'vue';
import Popover from '../common/Popover.vue';
import PrimaryButton from '../common/buttons/PrimaryButton.vue';
import SecondaryButton from '../common/buttons/SecondaryButton.vue';
import SuccessIcon from '../common/icons/SuccessIcon.vue';
import RequestNumberConfirmationBox from '@/components/common/RequestNumberConfirmationBox.vue';
import SecurePasswordForm from '@/components/common/form/SecurePasswordForm.vue';
import { mapActions as mapRootActions } from 'vuex';
import { createNamespacedHelpers } from 'vuex';
const { mapState, mapMutations, mapGetters, mapActions } = createNamespacedHelpers('confirm');
export default Vue.extend({
    components: {
        SuccessIcon,
        SecondaryButton,
        PrimaryButton,
        Popover,
        RequestNumberConfirmationBox,
        SecurePasswordForm,
    },
    data: function() {
        return {
            submitted: false,
        };
    },
    computed: {
        ...mapState(['refNo', 'isSaving']),
        ...mapGetters(['isFormValid']),
    },
    methods: {
        ...mapMutations(['setPasswordCreated', 'setPassword', 'setPasswordConfirmation']),
        ...mapActions(['signUp']),
        ...mapRootActions(['addError']),
        async submit() {
            await this.signUp();
            if (!this.isFormValid) {
                return;
            }
            this.submitted = true;
        },
        goToVerifyPage() {
            this.$router.push({ name: 'VerifyPage', query: { refNo: this.refNo } });
        },
        onHide() {
            if (this.submitted) {
                this.setPasswordCreated({ passwordCreated: true });
            }
            this.setPassword({ password: '' });
            this.setPasswordConfirmation({ passwordConfirmation: '' });
        },
    },
});
